"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headlineWrap = exports.headlineWidth = exports.ellipsis = exports.buttonBase = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var colour = _feBrary.variables.colour;
var buttonBase = exports.buttonBase = /*#__PURE__*/(0, _core.css)("display:inline-block;background:none;margin:0;padding:0;border:0;outline:none;cursor:pointer;color:", colour.neutral600, ";");
var headlineWidth = exports.headlineWidth = '500px';
var headlineWrap = exports.headlineWrap = /*#__PURE__*/(0, _core.css)("word-wrap:break-word;hyphens:auto;", (0, _feBrary.media)('>=desktop'), "{max-width:", headlineWidth, ";}");

/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
var ellipsis = (lines, lineHeight) => /*#__PURE__*/(0, _core.css)("display:block;display:-webkit-box;-webkit-line-clamp:", lines, ";-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;max-height:calc(", lines, " * ", lineHeight, ");");
exports.ellipsis = ellipsis;